<template>

<video  controls preload="auto" style='width: 100%;height: 100%' x5-playsinline="" playsinline="" webkit-playsinline="">
    <source id="source" :src="Livestreaming" :type="type"/>
</video>

</template>

<script>
export default {
    props:["Livestreaming","type"],
    data(){
        return{
            isplay:false,
        }
    }
    
}
</script>

<style>

</style>